export default __webpack_public_path__ + "static/media/childishGambino.b69e2f5e.jpeg";